import { useState, useRef } from "react";

const GOLD = "#F9A826";
const BLUE = "#0f1729";
const TONS = ["C","C#","D","D#","E","F","F#","G","G#","A","A#","B"];

const API = process.env.REACT_APP_API_URL || "https://adorateam-api-532602191494.us-central1.run.app";
function getToken() { return localStorage.getItem("adorateam_token"); }

export default function EditarCifra({ musica, onSalvar, onCancelar, tema }) {
    const T = tema;
    const [aba, setAba] = useState("cifra");
    const [titulo,           setTitulo]           = useState(musica.titulo     || "");
    const [tom,              setTom]              = useState(musica.tom        || "C");
    const [cifra,            setCifra]            = useState(musica.cifra      || "");
    const [tomViolao,        setTomViolao]        = useState(musica.tomViolao  || "");
    const [capotraste,       setCapotraste]       = useState(musica.capotraste || "");
    const [usarVersaoViolao, setUsarVersaoViolao] = useState(!!musica.tomViolao);
    const [salvando,         setSalvando]         = useState(false);
    const [previewLinhas,    setPreviewLinhas]    = useState(false);

    // Partitura
    const [partituraUrl,   setPartituraUrl]   = useState(musica.partituraUrl  || musica.partitura_url  || null);
    const [partituranome,  setPartituranome]  = useState(musica.partituranome || musica.partitura_nome || null);
    const [uploadandoPartitura, setUploadandoPartitura] = useState(false);
    const filePartituraRef = useRef(null);

    const uploadPartitura = async (file) => {
        if (!file) return;
        setUploadandoPartitura(true);
        try {
            const form = new FormData();
            form.append("partitura", file);
            const res = await fetch(`${API}/api/musicas/${musica.id}/partitura`, {
                method: "POST",
                headers: { Authorization: `Bearer ${getToken()}` },
                body: form,
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.erro || "Erro no upload");
            setPartituraUrl(data.url || data.partituraUrl);
            setPartituranome(file.name);
        } catch (e) {
            alert("Erro ao enviar partitura: " + e.message);
        } finally {
            setUploadandoPartitura(false);
        }
    };

    const removerPartitura = () => {
        setPartituraUrl(null);
        setPartituranome(null);
    };

    const salvar = () => {
        if (!titulo.trim()) return alert("Coloca o título da música!");
        if (!cifra.trim())  return alert("A cifra não pode estar vazia!");
        setSalvando(true);
        setTimeout(() => {
            onSalvar({
                ...musica,
                titulo:       titulo.trim(),
                tom,
                cifra,
                tomViolao:    usarVersaoViolao ? tomViolao  : "",
                capotraste:   usarVersaoViolao ? capotraste : "",
                partituraUrl,
                partituranome,
            });
            setSalvando(false);
        }, 300);
    };

    const linhas = cifra.split("\n").length;
    const isPDF = (partituranome || partituraUrl || "").toLowerCase().endsWith(".pdf");

    return (
        <div style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", zIndex: 500,
            display: "flex", alignItems: "flex-end", justifyContent: "center"
        }}>
            <div style={{
                background: T.bgCard, borderRadius: "24px 24px 0 0",
                width: "100%", maxWidth: 430, maxHeight: "94vh",
                overflowY: "auto", padding: 24, boxSizing: "border-box",
                boxShadow: "0 -8px 40px rgba(0,0,0,0.5)"
            }}>
                {/* Header */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 800, color: T.texto }}>✏️ Editar Música</div>
                        <div style={{ fontSize: 12, color: T.textoSecundario }}>Espaços e alinhamento preservados</div>
                    </div>
                    <button onClick={onCancelar} style={{
                        background: T.bgCardSecundario, border: "none", borderRadius: 20,
                        width: 36, height: 36, fontSize: 18, cursor: "pointer", color: T.texto
                    }}>✕</button>
                </div>

                {/* Abas */}
                <div style={{ display: "flex", background: T.bgCardSecundario, borderRadius: 12, padding: 4, marginBottom: 20, gap: 3 }}>
                    {[["cifra", "🎸 Cifra"], ["partitura", "📄 Partitura"]].map(([id, label]) => (
                        <button key={id} onClick={() => setAba(id)} style={{
                            flex: 1, padding: "8px 0", borderRadius: 9, border: "none",
                            background: aba === id ? GOLD : "transparent",
                            color: aba === id ? BLUE : T.textoSecundario,
                            fontWeight: aba === id ? 800 : 500,
                            fontSize: 13, cursor: "pointer", transition: "all 0.15s",
                        }}>{label}</button>
                    ))}
                </div>

                {/* ── ABA CIFRA ── */}
                {aba === "cifra" && (
                    <>
                        {/* Título */}
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: T.textoSecundario, marginBottom: 6 }}>TÍTULO DA MÚSICA</div>
                            <input
                                value={titulo}
                                onChange={e => setTitulo(e.target.value)}
                                placeholder="Ex: Oceanos"
                                style={{
                                    width: "100%", padding: "12px 14px", borderRadius: 12,
                                    border: `2px solid ${titulo ? GOLD + "88" : T.borda}`,
                                    background: T.bgCardSecundario, color: T.texto,
                                    fontSize: 15, fontWeight: 600, boxSizing: "border-box", outline: "none"
                                }}
                            />
                        </div>

                        {/* Tom */}
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: T.textoSecundario, marginBottom: 8 }}>TOM ORIGINAL</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                {TONS.map(t => (
                                    <button key={t} onClick={() => setTom(t)} style={{
                                        padding: "6px 14px", borderRadius: 10,
                                        border: `1px solid ${tom === t ? GOLD : T.borda}`,
                                        background: tom === t ? GOLD : T.bgCardSecundario,
                                        color: tom === t ? BLUE : T.texto,
                                        fontSize: 13, fontWeight: 600, cursor: "pointer"
                                    }}>{t}</button>
                                ))}
                            </div>
                        </div>

                        {/* Cifra */}
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                                <div style={{ fontSize: 12, fontWeight: 600, color: T.textoSecundario }}>CIFRA</div>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 11, color: T.textoSecundario }}>{linhas} linhas</span>
                                    <button onClick={() => setPreviewLinhas(p => !p)}
                                            style={{ fontSize: 10, background: previewLinhas ? `${GOLD}22` : T.bgCardSecundario, border: `1px solid ${T.borda}`, borderRadius: 6, padding: "2px 8px", cursor: "pointer", color: previewLinhas ? GOLD : T.textoSecundario }}>
                                        {previewLinhas ? "Editor" : "Preview"}
                                    </button>
                                </div>
                            </div>
                            {previewLinhas ? (
                                <div style={{ background: T.bgCardSecundario, borderRadius: 12, padding: "12px 14px", border: `1px solid ${T.borda}`, fontFamily: "monospace", fontSize: 13, lineHeight: 1.7, whiteSpace: "pre", overflowX: "auto", minHeight: 200, color: T.texto }}>
                                    {cifra || <span style={{ color: T.textoSecundario, fontStyle: "italic" }}>Cifra vazia...</span>}
                                </div>
                            ) : (
                                <textarea
                                    value={cifra}
                                    onChange={e => setCifra(e.target.value)}
                                    rows={14}
                                    spellCheck={false}
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    placeholder={`[Intro] C  G  Am  F\n\n[Verso]\n    C              G\nLetra da música aqui\n\n[Refrão]\nC   G   Am   F`}
                                    style={{
                                        width: "100%", padding: "12px 14px", borderRadius: 12,
                                        border: `1px solid ${T.borda}`,
                                        background: T.bgCardSecundario, color: T.texto,
                                        fontSize: 13, fontFamily: "'Courier New', monospace",
                                        lineHeight: 1.7, whiteSpace: "pre",
                                        overflowWrap: "off", boxSizing: "border-box",
                                        resize: "vertical", outline: "none", overflowX: "auto",
                                    }}
                                />
                            )}
                            <div style={{ fontSize: 11, color: T.textoSecundario, marginTop: 6, lineHeight: 1.5 }}>
                                💡 Use espaços para alinhar acordes acima da letra.
                                Seções: <span style={{ color: GOLD }}>[Intro]</span> <span style={{ color: GOLD }}>[Verso]</span> <span style={{ color: GOLD }}>[Refrão]</span>
                            </div>
                        </div>

                        {/* Versão violão */}
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: T.bgCardSecundario, borderRadius: 12, padding: "12px 14px", border: `1px solid ${T.borda}`, marginBottom: 10 }}>
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 700, color: T.texto }}>🎸 Versão para violão</div>
                                    <div style={{ fontSize: 11, color: T.textoSecundario }}>Com capotraste em outra tonalidade</div>
                                </div>
                                <div onClick={() => setUsarVersaoViolao(p => !p)} style={{ width: 46, height: 26, borderRadius: 13, cursor: "pointer", background: usarVersaoViolao ? GOLD : T.borda, position: "relative", transition: "background 0.2s" }}>
                                    <div style={{ position: "absolute", top: 3, left: usarVersaoViolao ? 23 : 3, width: 20, height: 20, borderRadius: "50%", background: "white", transition: "left 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.25)" }} />
                                </div>
                            </div>
                            {usarVersaoViolao && (
                                <div style={{ background: T.bgCardSecundario, borderRadius: 12, padding: 14, border: `1px solid ${GOLD}44` }}>
                                    <div style={{ display: "flex", gap: 12 }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: 11, color: T.textoSecundario, marginBottom: 6 }}>Tom para tocar</div>
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                                {TONS.map(t => (
                                                    <button key={t} onClick={() => setTomViolao(t)} style={{ padding: "4px 10px", borderRadius: 8, border: `1px solid ${tomViolao === t ? GOLD : T.borda}`, background: tomViolao === t ? GOLD : T.bgCard, color: tomViolao === t ? BLUE : T.texto, fontSize: 11, fontWeight: 600, cursor: "pointer" }}>{t}</button>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ width: 90 }}>
                                            <div style={{ fontSize: 11, color: T.textoSecundario, marginBottom: 6 }}>Casa do capo</div>
                                            <select value={capotraste} onChange={e => setCapotraste(e.target.value)} style={{ width: "100%", padding: "8px 10px", borderRadius: 10, border: `1px solid ${capotraste ? GOLD : T.borda}`, background: T.bgCard, color: T.texto, fontSize: 13, outline: "none" }}>
                                                <option value="">Sem capo</option>
                                                {Array.from({ length: 12 }, (_, i) => <option key={i+1} value={i+1}>{i+1}ª casa</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    {tomViolao && capotraste && (
                                        <div style={{ marginTop: 10, padding: "8px 12px", background: `${GOLD}15`, borderRadius: 10, border: `1px solid ${GOLD}33`, fontSize: 12, color: T.texto }}>
                                            🎸 Violão toca em <strong style={{ color: GOLD }}>{tomViolao}</strong> com capo na <strong style={{ color: GOLD }}>{capotraste}ª casa</strong> — soa em <strong style={{ color: GOLD }}>{tom}</strong>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* ── ABA PARTITURA ── */}
                {aba === "partitura" && (
                    <div style={{ marginBottom: 20 }}>
                        {partituraUrl ? (
                            <div>
                                {/* Preview */}
                                <div style={{ background: T.bgCardSecundario, borderRadius: 16, overflow: "hidden", border: `1px solid ${T.borda}`, marginBottom: 12 }}>
                                    {isPDF ? (
                                        <div style={{ padding: 20, display: "flex", alignItems: "center", gap: 14 }}>
                                            <div style={{ width: 48, height: 48, borderRadius: 12, background: "#f4433618", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <svg width="28" height="28" viewBox="0 0 24 24" fill="#f44336"><path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7H20.5v1.5z"/></svg>
                                            </div>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ fontSize: 14, fontWeight: 700, color: T.texto, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{partituranome || "Partitura.pdf"}</div>
                                                <div style={{ fontSize: 11, color: T.textoSecundario }}>PDF · Toque para abrir</div>
                                            </div>
                                            <a href={partituraUrl} target="_blank" rel="noreferrer" style={{ padding: "6px 12px", borderRadius: 8, background: `${GOLD}18`, border: `1px solid ${GOLD}44`, color: GOLD, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                                                Abrir ↗
                                            </a>
                                        </div>
                                    ) : (
                                        <img src={partituraUrl} alt="Partitura" style={{ width: "100%", display: "block", maxHeight: 300, objectFit: "contain" }} />
                                    )}
                                </div>

                                {/* Botões */}
                                <div style={{ display: "flex", gap: 8 }}>
                                    <input ref={filePartituraRef} type="file" accept="image/*,application/pdf" style={{ display: "none" }}
                                           onChange={e => { uploadPartitura(e.target.files[0]); e.target.value = ""; }} />
                                    <button onClick={() => filePartituraRef.current?.click()} disabled={uploadandoPartitura}
                                            style={{ flex: 1, padding: "10px 0", borderRadius: 12, background: T.bgCardSecundario, border: `1px solid ${T.borda}`, color: T.texto, fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: uploadandoPartitura ? 0.6 : 1 }}>
                                        {uploadandoPartitura ? "⏳ Enviando..." : "🔄 Trocar"}
                                    </button>
                                    <button onClick={removerPartitura}
                                            style={{ padding: "10px 16px", borderRadius: 12, background: "#f4433612", border: "1px solid #f4433633", color: "#f44336", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                                        🗑 Remover
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {/* Upload área */}
                                <input ref={filePartituraRef} type="file" accept="image/*,application/pdf" style={{ display: "none" }}
                                       onChange={e => { uploadPartitura(e.target.files[0]); e.target.value = ""; }} />
                                <button onClick={() => filePartituraRef.current?.click()} disabled={uploadandoPartitura}
                                        style={{
                                            width: "100%", padding: "32px 20px",
                                            borderRadius: 16, border: `2px dashed ${GOLD}55`,
                                            background: uploadandoPartitura ? T.bgCardSecundario : `${GOLD}08`,
                                            cursor: uploadandoPartitura ? "default" : "pointer",
                                            display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
                                        }}>
                                    <div style={{ fontSize: 40 }}>{uploadandoPartitura ? "⏳" : "📄"}</div>
                                    <div style={{ fontSize: 14, fontWeight: 700, color: GOLD }}>
                                        {uploadandoPartitura ? "Enviando partitura..." : "Anexar partitura"}
                                    </div>
                                    <div style={{ fontSize: 12, color: T.textoSecundario }}>
                                        Suporta PDF, JPG, PNG
                                    </div>
                                </button>
                                <div style={{ marginTop: 12, padding: "10px 14px", background: T.bgCardSecundario, borderRadius: 12, border: `1px solid ${T.borda}`, fontSize: 12, color: T.textoSecundario }}>
                                    💡 A partitura fica disponível na aba <strong style={{ color: T.texto }}>Partitura</strong> da música para todos os membros.
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Botões de ação */}
                <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                    <button onClick={onCancelar} style={{ flex: 1, padding: 14, background: T.bgCardSecundario, border: "none", borderRadius: 14, cursor: "pointer", color: T.texto, fontWeight: 600, fontSize: 14 }}>
                        Cancelar
                    </button>
                    <button onClick={salvar} disabled={salvando} style={{
                        flex: 2, padding: 14,
                        background: salvando ? T.borda : `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                        border: "none", borderRadius: 14,
                        cursor: salvando ? "default" : "pointer",
                        color: BLUE, fontWeight: 800, fontSize: 15,
                        boxShadow: salvando ? "none" : `0 4px 20px ${GOLD}44`
                    }}>
                        {salvando ? "Salvando..." : "✓ Salvar alterações"}
                    </button>
                </div>
            </div>
        </div>
    );
}